import { getCmsNetworkMapStationInfo } from "../../../app/api/getCmsNetworkMapStations";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsNetworkMapStationInfoResponse } from "../../../Orchestrator/Types/Index";
import { getLocaleFromCookie } from "../../../Lib/Utils/getLocaleFromCookie";
import { DEFAULT_LOCALE } from "../../../config/global";

class GetCmsNetworkMapStationInfoAction extends BaseAction<ICmsNetworkMapStationInfoResponse | null, void> {
  override async run(): Promise<ICmsNetworkMapStationInfoResponse | null> {
    let result: ICmsNetworkMapStationInfoResponse | null = null;
    try {
      const response = await getCmsNetworkMapStationInfo();
      if (response.status === "ok" && response.answer) {
        result = response.answer;
      } else {
        console.warn("Failed to fetch data.");
      }

      // The localized single-type (e.g. ar) can have no desktop_map when its
      // CMS localization is incomplete — the network map is a shared diagram,
      // so fall back to the default-locale entry instead of rendering
      // "No image available" on non-default locales.
      if (!result?.data?.desktop_map?.url && getLocaleFromCookie() !== DEFAULT_LOCALE) {
        const fallback = await getCmsNetworkMapStationInfo(DEFAULT_LOCALE);
        if (fallback.status === "ok" && fallback.answer?.data?.desktop_map?.url) {
          result = fallback.answer;
        }
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      updateRecoilState("networkMapStationInfoResponseAtom", result);
      return result;
    }
  }
}

export const getCmsNetworkMapStationInfoAction = new GetCmsNetworkMapStationInfoAction();
